require('normalize.css/normalize.css')
require('../css/main.css')
require('../partials/nav.js')

const send = document.getElementById('send-message');
const firstName = document.getElementById('first_name');
const email = document.getElementById('email');
const message = document.getElementById('message');
const firstNameValidate = document.getElementById('first_name_validate')
const emailValidate = document.getElementById('email_validate')
const messageValidate = document.getElementById('message_validate')

send.addEventListener('click', () => {
  validateFirstName();
  validateEmail();
  validateMessage();
  
  if (isValid()) {
    console.log('we can send an email now');
  }
})

firstName.addEventListener('input', () => {
  validateFirstName();
})

email.addEventListener('input', () => {
  validateEmail();
})

message.addEventListener('input', () => {
  validateMessage();
})

const validateFirstName = function () {
  if (firstName.value.trim() !== '') {
    firstNameValidate.classList.add('hidden');
    firstName.classList.remove('border-red-600');
  } else {
    firstNameValidate.classList.remove('hidden');
    firstName.classList.add('border-red-600');
  }
}

const validateEmail = function () {
  if (email.value.trim() !== '') {
    emailValidate.classList.add('hidden');
    email.classList.remove('border-red-600');
  } else {
    emailValidate.classList.remove('hidden');
    email.classList.add('border-red-600');
  }
}

const validateMessage = function () {
  if (message.value.trim() !== '') {
    messageValidate.classList.add('hidden');
    message.classList.remove('border-red-600');
  } else {
    messageValidate.classList.remove('hidden');
    message.classList.add('border-red-600');
  }
}

const isValid = function () {
  return (firstNameValidate.classList.contains('hidden') && emailValidate.classList.contains('hidden') && messageValidate.classList.contains('hidden'));
}




